import { render, staticRenderFns } from "./ConfirmBoxModal.vue?vue&type=template&id=9ca6d778&scoped=true&"
import script from "./ConfirmBoxModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmBoxModal.vue?vue&type=style&index=0&id=9ca6d778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca6d778",
  null
  
)

export default component.exports